import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-warm-900 border-t border-warm-800 py-8 px-4" data-id="element-29">
        <div className="max-w-6xl mx-auto" data-id="element-30">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-31">
            <p className="text-cream/50 text-sm" data-id="element-32">
              © {new Date().getFullYear()} ¿Qué Cocino? Nunca Más. Todos los
              derechos reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-33">
              <button onClick={() => setShowPrivacy(true)} className="text-cream/50 hover:text-sage-light text-sm transition-colors" data-id="element-34">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="text-cream/50 hover:text-sage-light text-sm transition-colors" data-id="element-35">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {showPrivacy && <Modal onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-36">
          <div className="space-y-4 text-warm-800" data-id="element-37">
            <p data-id="element-38">
              En ¿Qué Cocino? Nunca Más, nos comprometemos a proteger tu
              privacidad y la seguridad de tus datos personales.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-39">
              Información que Recopilamos
            </h3>
            <p data-id="element-40">
              Recopilamos información que nos proporcionas directamente al
              realizar una compra, incluyendo tu nombre, dirección de correo
              electrónico y datos de pago procesados de forma segura a través de
              nuestros proveedores de pago.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-41">
              Uso de la Información
            </h3>
            <p data-id="element-42">Utilizamos tu información para:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-43">
              <li data-id="element-44">Procesar y entregar tu compra del sistema completo</li>
              <li data-id="element-45">
                Enviarte actualizaciones y contenido relacionado con el producto
              </li>
              <li data-id="element-46">Mejorar nuestros servicios y experiencia del cliente</li>
              <li data-id="element-47">Cumplir con obligaciones legales</li>
            </ul>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-48">Protección de Datos</h3>
            <p data-id="element-49">
              Implementamos medidas de seguridad técnicas y organizativas
              apropiadas para proteger tus datos personales contra acceso no
              autorizado, alteración, divulgación o destrucción.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-50">Tus Derechos</h3>
            <p data-id="element-51">
              Tienes derecho a acceder, rectificar, eliminar o limitar el uso de
              tus datos personales. Para ejercer estos derechos, contáctanos a
              través de nuestro correo electrónico de soporte.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-52">Cookies</h3>
            <p data-id="element-53">
              Utilizamos cookies esenciales para el funcionamiento del sitio web
              y para medir el rendimiento de nuestras campañas publicitarias
              (Meta Pixel).
            </p>

            <p className="text-sm text-warm-800/60 mt-6" data-id="element-54">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
            </p>
          </div>
        </Modal>}

      {showTerms && <Modal onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-55">
          <div className="space-y-4 text-warm-800" data-id="element-56">
            <p data-id="element-57">
              Bienvenido a ¿Qué Cocino? Nunca Más. Al acceder y utilizar este
              sitio web y adquirir nuestros productos digitales, aceptas los
              siguientes términos y condiciones.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-58">Producto Digital</h3>
            <p data-id="element-59">
              ¿Qué Cocino? Nunca Más es un producto digital que incluye guías,
              tableros y listas en formato PDF. El acceso es inmediato tras la
              confirmación del pago.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-60">Licencia de Uso</h3>
            <p data-id="element-61">
              Al adquirir el producto, obtienes una licencia personal, no
              transferible, para uso privado. No está permitido:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-62">
              <li data-id="element-63">Compartir, revender o redistribuir el contenido</li>
              <li data-id="element-64">Reproducir o copiar el material para uso comercial</li>
              <li data-id="element-65">Modificar o crear obras derivadas sin autorización</li>
            </ul>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-66">
              Política de Reembolso
            </h3>
            <p data-id="element-67">
              Debido a la naturaleza digital del producto y el acceso inmediato,
              no ofrecemos reembolsos una vez que el contenido ha sido
              entregado. Te recomendamos revisar toda la información del
              producto antes de realizar tu compra.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-68">
              Descargo de Responsabilidad
            </h3>
            <p data-id="element-69">
              ¿Qué Cocino? Nunca Más proporciona información y estrategias
              prácticas. Los resultados pueden variar según cada persona y
              situación. No sustituye el consejo médico o nutricional
              profesional. Consulta con un profesional de la salud si tienes
              preocupaciones específicas sobre tu alimentación.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-70">
              Propiedad Intelectual
            </h3>
            <p data-id="element-71">
              Todo el contenido, incluyendo textos, gráficos, logos y diseños,
              está protegido por derechos de autor y es propiedad exclusiva de
              ¿Qué Cocino? Nunca Más.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-72">Modificaciones</h3>
            <p data-id="element-73">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación en el sitio web.
            </p>

            <h3 className="font-bold text-lg mt-6 mb-2" data-id="element-74">Ley Aplicable</h3>
            <p data-id="element-75">
              Estos términos se rigen por las leyes aplicables en tu
              jurisdicción. Cualquier disputa será resuelta en los tribunales
              competentes.
            </p>

            <p className="text-sm text-warm-800/60 mt-6" data-id="element-76">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
            </p>
          </div>
        </Modal>}
    </>;
}
interface ModalProps {
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  onClose,
  title,
  children
}: ModalProps) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-77">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} onClick={onClose} className="absolute inset-0 bg-warm-900/80 backdrop-blur-sm" data-id="element-78" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} className="relative bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-79">
        <div className="sticky top-0 bg-white border-b border-warm-200/60 px-6 py-4 flex items-center justify-between z-10" data-id="element-80">
          <h2 className="text-2xl font-bold font-heading text-warm-900" data-id="element-81">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-warm-100 rounded-full transition-colors text-warm-800" aria-label="Cerrar" data-id="element-82">
            <XIcon className="w-5 h-5" data-id="element-83" />
          </button>
        </div>

        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-160px)]" data-id="element-84">
          {children}
        </div>

        <div className="sticky bottom-0 bg-white border-t border-warm-200/60 px-6 py-4" data-id="element-85">
          <button onClick={onClose} className="w-full bg-sage-dark text-cream font-semibold py-3 px-6 rounded-xl hover:bg-warm-900 transition-colors" data-id="element-86">
            Cerrar
          </button>
        </div>
      </motion.div>
    </div>;
}